import { render, staticRenderFns } from "./HanbookDetail.vue?vue&type=template&id=b84f7b7c&scoped=true"
import script from "./HanbookDetail.vue?vue&type=script&lang=js"
export * from "./HanbookDetail.vue?vue&type=script&lang=js"
import style0 from "./HanbookDetail.vue?vue&type=style&index=0&id=b84f7b7c&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84f7b7c",
  null
  
)

export default component.exports